export default "__VITE_ASSET__DjBZN3i$__"